import { connect } from 'react-redux';
import { getChatPanelOpen, getChatUnreadCount, } from '../../../Chat/redux/selectors';
import { openChatPanel, closeChatPanel } from '../../../Chat/redux/actions';
var mapStateToProps = function (state) { return ({
    isOpen: getChatPanelOpen(state),
    chatCount: getChatUnreadCount(state),
}); };
var mapDispatchToProps = {
    onOpen: openChatPanel,
    onClose: closeChatPanel,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ChatButtonAndDropdown.container.js.map